module.exports = __webpack_public_path__ + "static/media/passport.4ae94f78.svg";